import { useEffect } from 'react';

export const useBodyScrollLock: (enabled: boolean) => void = (enabled: boolean): void => {
  useEffect(
    (): (() => void) => {
      if (!enabled) {
        return (): void => undefined;
      }

      const { body }: Document = document;
      const overflow: string = body.style.overflow;
      const paddingRight: string = body.style.paddingRight;
      const scrollbarWidth: number = window.innerWidth - document.documentElement.clientWidth;

      body.style.overflow = 'hidden';
      body.style.paddingRight = `${scrollbarWidth}px`;

      return (): void => {
        body.style.overflow = overflow;
        body.style.paddingRight = paddingRight;
      };
    },
    [enabled]
  );
};
